export default {
  data() {
    return {
      additional_ignored_properties: [],
      ignored_properties: [
        'created_at',
        'updated_at',
        'feed',
        'tags',
        'item_id',
        'item',
        'id',
        'rp_category_id',
        'artwork_id',
        'artwork',
        'storage',
        'storage_id',
      ],
      tag_properties: {
        unchanged: [],
        added: [],
        removed: [],
      },
    };
  },
  computed: {
    combined_ignored_properties() {
      return this.additional_ignored_properties.length ? _.merge(this.ignored_properties, this.additional_ignored_properties) : this.ignored_properties;
    },
    should_show_tags() {
      return this.tag_properties.added.length || this.tag_properties.removed.length;
    },
    filtered_row_properties() {
      const vm = this;
      let row_properties_copy = JSON.parse(JSON.stringify(this.rowProperties));

      const data = { attributes: {}, old: {} };

      if (row_properties_copy.attributes) {
        _.forEach(row_properties_copy.attributes, (attribute_value, attribute_key) => {
          if (!vm.combined_ignored_properties.includes(attribute_key)) {
            data['attributes'][attribute_key] = attribute_value;
          }
        });
      }

      if (row_properties_copy.old) {
        _.forEach(row_properties_copy.old, (attribute_value, attribute_key) => {
          if (!vm.combined_ignored_properties.includes(attribute_key)) {
            data['old'][attribute_key] = attribute_value;
          }
        });
      }

      row_properties_copy = data;

      return row_properties_copy;
    },
  },
  methods: {
    pluckSubProperties() {
      const vm = this;
      const properties_for_name_and_uuid = ['feed', 'item', 'artwork'];
      const keys = ['attributes', 'old'];

      _.forEach(keys, (key) => {
        if (!vm.rowProperties[key]) {
          return;
        }
        _.forEach(properties_for_name_and_uuid, (property) => {
          if (vm.rowProperties[key][property]) {
            vm.rowProperties[key][property] = _.pick(vm.rowProperties[key][property], 'name', 'uuid');
          }
        });
        // Others
        if (vm.rowProperties[key].radioPlayerCategory) {
          vm.rowProperties[key].radioPlayerCategory = vm.rowProperties[key].radioPlayerCategory.name;
        }
      });
    },
    setupTags() {
      const vm = this;
      const old_tags = this.rowProperties.old ? this.rowProperties.old.tags : [];
      const new_tags = this.rowProperties.attributes.tags;

      _.forEach(new_tags, (new_tag) => {
        const found = _.find(old_tags, tag => tag === new_tag);
        if (found) {
          vm.tag_properties.unchanged.push(new_tag);
        } else {
          vm.tag_properties.added.push(new_tag);
        }
      });

      _.forEach(old_tags, (old_tag) => {
        const found = _.find(new_tags, tag => tag === old_tag);

        if (!found) {
          vm.tag_properties.removed.push(old_tag);
        }
      });
    },
  },
  mounted() {
    this.pluckSubProperties();
    const can_setup_tags = this.rowProperties && this.rowProperties.attributes && this.rowProperties.attributes.tags;
    if (can_setup_tags) {
      this.setupTags();
      // Remove tags from row properties
      if (this.rowProperties.attributes && this.rowProperties.attributes.tags) {
        delete this.rowProperties.attributes.tags;
      }

      if (this.rowProperties.old && this.rowProperties.old.tags) {
        delete this.rowProperties.old.tags;
      }
    }
  },
  filters: {
    key_transform(value) {
      return value.replace("_", " ");
    },
  },
};
